import { get } from 'lodash';
import { scale as vegaScale, scheme as vegaScheme } from 'vega-lib';

import { CHART_CATEGORIES } from 'constants/chart-categories';
import { HEATMAP_DEFAULTS } from 'constants/geospatial';

const STEPS = [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];

export default {
  name: 'Geospatial Heatmap',
  displayName: 'Heatmap',
  order: 2,
  flavour: 'geo',
  category: CHART_CATEGORIES.GEOSPATIAL,
  iconValue: 'geo-heatmap',
  channels: [
    {
      name: 'geopoint',
      displayName: 'Coordinates',
      required: true,
      channelType: 'geopoint',
      intent: 'geopoint',
      nestedChannels: [
        {
          name: 'longitude',
          displayName: 'Longitude',
          required: true,
          channelType: 'number',
          intent: 'undefined',
        },
        {
          name: 'latitude',
          displayName: 'Latitude',
          required: true,
          channelType: 'number',
          intent: 'undefined',
        },
      ],
    },
    {
      name: 'intensity',
      displayName: 'Intensity',
      required: true,
      channelType: 'aggregation',
      intent: 'value-axis',
    },
  ],
  specFn: (encodings, customisations) => {
    const color = get(
      customisations.options,
      'colorContinuous.value.color',
      'rainbow'
    );
    const reverseColor = get(
      customisations.options,
      'colorContinuous.value.reverse',
      false
    );
    const seq = vegaScale('sequential');
    const colorScheme = seq().interpolator(vegaScheme(color));

    const gradient = STEPS.reduce(
      (acc, val) => ({
        ...acc,
        [val]: reverseColor ? colorScheme(1.0 - val) : colorScheme(val),
      }),
      {}
    );

    return {
      radius: parseInt(
        get(
          customisations.options,
          'heatmapRadius.value',
          HEATMAP_DEFAULTS.radius
        ),
        10
      ),
      opacity:
        parseInt(
          get(
            customisations.options,
            'geospatialOpacity.value',
            HEATMAP_DEFAULTS.opacity
          ),
          10
        ) / 100,
      gradient,
    };
  },
};
